<div class="splash-page">
  <p class="splash-page__readonly--text">Creating a new Chase is easy, just follow <br />our simple step-by-step instructions.</p>
  <app-button class="process-button" text="GET STARTED" (onClick)="showStepsMenuScreen()"></app-button>
</div>
